// Recovered compiled webpack factory 15278. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "AsyncMetadataOutlet", {
      enumerable: !0,
      get: function () {
        return i;
      },
    }));
  let n = r(95155),
    a = r(12115);
  function o(e) {
    let { promise: t } = e,
      { error: r, digest: n } = (0, a.use)(t);
    if (r) throw (n && (r.digest = n), r);
    return null;
  }
  function i(e) {
    let { promise: t } = e;
    return (0, n.jsx)(a.Suspense, { fallback: null, children: (0, n.jsx)(o, { promise: t }) });
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
